<template>
  <div id="noti">
    <b-nav-item-dropdown class="notification p-0" v-b-tooltip.hover title="Notificaciones" >
      <template slot="button-content">
        <i class="fas fa-bell"></i>
        <span class="bgg-title">Notificaciones</span>
        <span class="badge badge-danger ml-1 bg-notification" v-if="noReadNotifications">
                    <b-spinner small label="Small Spinner" type="grow"></b-spinner>
                </span>
      </template>
      <b-dropdown-item class="_all_notification font-weight-bold">
        <i class="fas fa-bell"></i> Notificaciones
      </b-dropdown-item>

      <b-dropdown-item class="notification_item b-gray-light" v-for="notification in notificationsList"
                       :key="notification.id" @click="makeRead(notification.id, notification.data.url_redirect)">
        <div class="shadow-sm rounded d-flex my-1 py-1" :class="notification.read_at ? 'b-gray-light' : 'b-white'">
          <div class="icon m-1">
            <img src="@/assets/profile/user_empty.png" alt="" width="" height="" class="img-fluid rounded-circle">
          </div>
          <div class="notify mx-2">
            <div class="d-block ellipsis-l1">{{notification.data.title}}</div>
            <small class="float-right font-gray-dark">hace {{notification.created_at | timeDateHummand}}</small>
          </div>
        </div>
      </b-dropdown-item>
      <b-dropdown-item class="_nofound b-gray-light" v-if="notificationsList.length == 0">
        <div class="py-3 mx-5">
          No hay notificaciones por mostrar
        </div>
      </b-dropdown-item>
      <b-dropdown-item to="/notificaciones" class="_all_notification">
                <span class="font-blue">
                    <i class="fas fa-stream"></i> Ver todas las notificaciones
                </span>
      </b-dropdown-item>
    </b-nav-item-dropdown>
  </div>
</template>
<style lang="scss" scoped>
  @media only screen and (min-width: 320px) {
    .bgg-title {
      display: inline
    }
  }

  @media only screen and (min-width: 550px) {
    .bgg-title {
      display: none
    }
  }
</style>
<script>
  export default {
    name: 'Notifications',
    props: {
      notificationsList: Array
    },
    data() {
      return {
        readNotification: true,
        noReadNotifications: 0,
        downloading: false,
      }
    },
    watch: {
      notificationsList: {
        deep: true,
        handler: function (notify) {
          notify.forEach(element => {
            if (!element.read_at) {
              this.noReadNotifications++
            }
          })
        }
      }
    },
    methods: {
      makeRead(id, redirect) {
        this.api.get('notification/read/' + id).then(({data}) => {
          if (this.noReadNotifications > 0) {
            this.noReadNotifications--
          }

          let redirect_2 = redirect.split("/").join("");
          let path_actual = decodeURIComponent(window.location.pathname).split("/").join("");

          if (redirect_2 !== path_actual) {
            this.$router.push(redirect)
          }else{
            location.reload()
          }
        })
      },
      makeReadAll() {
        alert('read all')
      }
    },
    mounted() {
      this.$root.$on('bv::dropdown::show', bvEvent => {
        //On Open DropDown
      })
    }
  }
</script>
<style lang="scss" >
#noti{
  z-index: 2000;
}

</style>


// WEBPACK FOOTER //
// src/components/notificaciones/TheTopNotifications.vue